// extracted by mini-css-extract-plugin
module.exports = {"header_box":"header_box-1Xzohcvy","header":"header-3W_z5t59 clearfix","channel":"channel-3bBm6pIb","user":"user-2NiULZ1Y","link":"link-33Fqmo0D","devide":"devide-2RNZCTch"};